import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Delete: FC<ISvG> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.624"
      height="17.533"
      viewBox="0 0 15.624 17.533"
    >
      <g
        id="Сгруппировать_4191"
        data-name="Сгруппировать 4191"
        transform="translate(-288.215 -245.495)"
      >
        <g id="Сгруппировать_4187" data-name="Сгруппировать 4187">
          <g id="Сгруппировать_4186" data-name="Сгруппировать 4186">
            <g id="Сгруппировать_4185" data-name="Сгруппировать 4185">
              <path
                id="Контур_789"
                data-name="Контур 789"
                d="M289.331,261.1a2.1,2.1,0,0,0,2.232,1.929h8.928a2.1,2.1,0,0,0,2.231-1.929V249.524H289.331Z"
                fill="#858e95"
              />
              <path
                id="Контур_790"
                data-name="Контур 790"
                d="M299.933,246.488l-1.116-.993h-5.58l-1.116.993h-3.906v1.985h15.624v-1.985Z"
                fill="#858e95"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default memo(Delete);
